import {PanelBarItem} from "@progress/kendo-react-layout/dist/npm/panelbar/PanelBarItem";
import {PanelBar} from "@progress/kendo-react-layout/dist/npm/panelbar/PanelBar";
import classes from "./BPPForm.module.scss";
import {Label} from "@progress/kendo-react-labels";
import {
    Checkbox,
    CheckboxChangeEvent,
    Input,
    InputChangeEvent, RadioGroup, RadioGroupChangeEvent,
    TextAreaChangeEvent
} from "@progress/kendo-react-inputs";
import {IFormFiledInterface} from "../../../../../interfaces/form-filed.interface";
import {IFormSettingModel} from "../../../../../interfaces/form-settings.interface";
import {IBppFormSixthSectionInterface} from "../../../../../interfaces/forms/BPPForm/bpp-form-sixth-section.interface";
import {DatePickerChangeEvent} from "@progress/kendo-react-dateinputs";
import {DropDownListChangeEvent} from "@progress/kendo-react-dropdowns";
import {useEffect, useRef, useState} from "react";
import SectionTitle from "../Shared/SectionTitle";

interface GeneralFormType {
    isAdminPreview?: boolean,
    formFields?: Array<IFormFiledInterface>,
    setFormDataFields: (form: IBppFormSixthSectionInterface) => void;
    formDataFields?:  IBppFormSixthSectionInterface,
    formSettings?: IFormSettingModel,
    setFormIsValid: (value: boolean) => void
}

export default function BPPFormSixthSection(props: GeneralFormType): JSX.Element {
    const formRef = useRef<HTMLFormElement>(null);
    const [isValid, setIsValid] = useState<boolean>(false);
    const [isFormTouched, setIsFormTouched] = useState<boolean>(false);
    const title = <SectionTitle isFormTouched={isFormTouched} isValid={isValid} number={6} name={"Market Value"}/>;
    const { formFields, setFormDataFields, formDataFields, formSettings, isAdminPreview, setFormIsValid } = props;

    const radioButtonData1 = [
        { label: "Under $20,000", value: "Under20K" },
        { label: "$20,000 or More", value: "Over20K" },
    ];

    const radioButtonData2 = [
        { label: "$125,000 or less", value: "Under125K" },
        { label: "More than $125,000", value: "Over125K" },
    ];


    function changeValueHandler(
        event:
            | CheckboxChangeEvent
            | DatePickerChangeEvent
            | TextAreaChangeEvent
            | DropDownListChangeEvent
            | InputChangeEvent
            | RadioGroupChangeEvent,
        field: string,
    )
    {
        setFormDataFields({
            ...formDataFields,
            [field]: event.value
        });
    }

    function changeValidator() {
        if(formRef.current) {
            setIsValid(formRef.current.checkValidity());
            setFormIsValid(formRef.current.checkValidity());
        }
    }

    function onTouch(){
        if(!isFormTouched){
            setIsFormTouched(true);
        }
    }

    useEffect(() => {
        changeValidator()
    }, [formDataFields, formRef.current]);


    return <>
        <PanelBar keepItemsMounted={true}>
            <PanelBarItem title={title} expanded={true}>
                <form name={"Name"} className={classes.sectionForm} ref={formRef} onFocus={onTouch}>
                    <div className="container">
                        <div className={classes.item}>
                            <div className={`${classes.itemFields}`}>
                                Select your property's total market value: 
                                <div className={classes.fieldsGroup}>                                    
                                    <div className={classes.inputsGroup}>
                                        {radioButtonData1.map(option => (
                                            <label key={option.value} style={{ display: 'inline-block', marginBottom: '6px', marginLeft: '8px',cursor: 'pointer' }}>
                                            <input
                                                type="checkbox"
                                                disabled={formSettings?.isReadOnly}
                                                checked={formDataFields?.MarketValue === option.value}
                                                onChange={() => {
                                                const newValue = formDataFields?.MarketValue === option.value ? "" : option.value;
                                                 setFormDataFields({
                                                        ...(formDataFields || {}),
                                                        MarketValue: newValue
                                                    });
                                                }}
                                            />
                                            {option.label}
                                            </label>
                                        ))}
                                    </div>                                    
                                </div>
                                If you answered Under $20,000, please complete only Schedule A and if applicable, Schedule F. Otherwise, complete Schedule(s) B, C, D, E and/or F, as applicable.
                            </div>
                            
                            <div className={`${classes.itemFields}`}>
                                Select your property's total market value: 
                                <div className={classes.fieldsGroup}>                                    
                                    <div className={classes.inputsGroup}>
                                        {radioButtonData2.map(option => (
                                            <label key={option.value} style={{ display: 'inline-block', marginBottom: '6px', marginLeft: '8px',cursor: 'pointer' }}>
                                            <input
                                                type="checkbox"
                                                disabled={formSettings?.isReadOnly}
                                                checked={formDataFields?.MarketValue === option.value}
                                                onChange={() => {
                                                const newValue = formDataFields?.MarketValue === option.value ? "" : option.value;
                                                 setFormDataFields({
                                                        ...(formDataFields || {}),
                                                        MarketValue: newValue
                                                    });
                                                }}
                                            />
                                            {option.label}
                                            </label>
                                        ))}
                                    </div>                                    
                                </div>    
                            </div>
                            {formDataFields?.MarketValue == "Under125K" && <label className={classes.certificationLabel}>
                                <input
                                        type="checkbox"
                                        disabled={formSettings?.isReadOnly}
                                        checked={formDataFields?.IsMarketValueCertified || false}
                                        onChange={(e) =>
                                        setFormDataFields({
                                            ...(formDataFields || {}),
                                            IsMarketValueCertified: e.target.checked
                                        })
                                    }
                                />
                                By checking this box, I certify that the market value of the tangible
                                personal property is $125,000 or less.
                            </label>}
                        </div>
                    </div>
                </form>
            </PanelBarItem>
        </PanelBar>
    </>
}
